import { render, staticRenderFns } from "./MatrixQuestion.vue?vue&type=template&id=329ee1d4&scoped=true"
import script from "./MatrixQuestion.vue?vue&type=script&lang=js"
export * from "./MatrixQuestion.vue?vue&type=script&lang=js"
import style0 from "./MatrixQuestion.vue?vue&type=style&index=0&id=329ee1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329ee1d4",
  null
  
)

export default component.exports